import { BaseController } from "../../../core/controllers/base.controller";
import { NavController } from "ionic-angular";
import { combineLatest } from "rxjs/observable/combineLatest";
import { VasAppFacade } from "../../services/vas-app-facade.service";
import { SyncManagerButtonModel } from "./sync-manager-button.model";
import { Subject } from "rxjs/Subject";
import { Observable } from "rxjs/Observable";
import { ISyncManagerPageArgs } from "../../pages/sync-manager/sync-manager";

export class SyncManagerButtonController extends BaseController {

    protected _model$ = new Subject<SyncManagerButtonModel>();
    protected model: SyncManagerButtonModel;

    constructor(
        protected appFacade: VasAppFacade,
        protected navController: NavController
    ) {
        super();
    }

    ngOnInit(): void {

        this.appFacade.whenAppReady()
            .take(1)
            .concatMap(() => {
                return combineLatest(
                    this.appFacade.objects.account.store.getActive(),
                    this.appFacade.objects.syncUpItem.store.getAll()
                );
            })
            .map(([account, syncUpItems]) => {
                return SyncManagerButtonModel.getInstance({
                    account,
                    syncUpItems
                });
            })
            .do(model => this.model = model)
            .subscribe(model => this._model$.next(model));
    }

    protected get accountId(): string {
        return this.model ? this.model.accountId : "";
    }

    get model$(): Observable<SyncManagerButtonModel> {
        return this._model$;
    }

    openSyncManager(): void {

        if (!this.accountId) {
            return;
        }

        this.navController.push("SyncManagerPage", {
            accountId: this.accountId
        } as ISyncManagerPageArgs);
    }
}



// WEBPACK FOOTER //
// ./src/vas/modules-other/sync-manager-button/sync-manager-button.controller.ts